import React from 'react'
import axios from 'axios'
import { baseUrl } from '../assets/Animations'
import './cancellation-spreadsheet.css'
import EditTimesheet from '../CreateTimesheet/EditTimesheet/EditTimesheet'
import CancellationEditTimesheet from './CancellationEditTimesheet/CancellationEditTimesheet'

const CancellationSpreadsheet = () => {
    const [currentMonth, setCurrentMonth] = React.useState('')
    const [currentYear, setCurrentYear] = React.useState('')
    const [altMonth, setAltMonth] = React.useState('')
    const [altYear, setAltYear] = React.useState('')
    const [month, setMonth] = React.useState(false)
    const [year, setYear] = React.useState(false)
    const listOfMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const [timesheets, setTimesheets] = React.useState([])
    const [lastMonthsTimesheets, setLastMonthsTimesheets] = React.useState([])
    const [newMaster, setNewMaster] = React.useState([])
    const [lastMonthsMaster, setLastMonthsMaster] = React.useState([])
    const [schoolTab, setSchoolTab] = React.useState('mma')
    const [noteHoverMessage, setNoteHoverMessage] = React.useState(false)
    const [openTimesheet, setOpenTimesheet] = React.useState(false)
    const [listOfFamilies, setListOfFamilies] = React.useState([])

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        createDateSettings()
    }, [])

    React.useEffect(() => {
        let allTabs = document.getElementsByClassName('cancellations__school-tab')
        for(let i = 0; i < allTabs.length; i++) {
            allTabs[i].style.borderBottom = '1px solid #fff'
            allTabs[i].style.color = '#000'
            allTabs[i].style.fontWeight = 100
        }
        document.getElementById(`${schoolTab}-cancellations__school-tab`).style.borderBottom = '1px solid orange'
        document.getElementById(`${schoolTab}-cancellations__school-tab`).style.color = 'orange'
        document.getElementById(`${schoolTab}-cancellations__school-tab`).style.fontWeight = 900
    }, [schoolTab])

    React.useEffect(() => {
        if(month && year) {
            axios.get(`${baseUrl}/teachertimesheet/${month}/${year}`, myHeader)
            .then((res) => {
                setTimesheets(res.data)
                prepAllTimesheetData(res.data, setNewMaster)
            })
            .catch((err) => {
                console.log(err)
            })
        }
        for(let i = 0; i < listOfMonths.length; i++) {
            if(listOfMonths[i] === month) {
                if(i === 0) {
                    setAltMonth(listOfMonths[11])
                    setAltYear(year - 1)
                } else {
                    setAltMonth(listOfMonths[i - 1])
                    setAltYear(year)
                }
            }
        }
    }, [month, year])

    React.useEffect(() => {
        if(altMonth && altYear) {
            axios.get(`${baseUrl}/teachertimesheet/${altMonth}/${altYear}`, myHeader)
            .then((res) => {
                setLastMonthsTimesheets(res.data)
                prepAllTimesheetData(res.data, setLastMonthsMaster)
            })
            .catch((err) => {
                console.log(err)
            })
        }
    }, [altMonth, altYear])

    const createDateSettings = () => {
        let d = new Date()
        let theMonth = d.getMonth()
        let day = d.getDate()
        let theYear = d.getFullYear()
        let adjustedMonth;
        if(day < 15) {
            if(theMonth !== 0) {
                adjustedMonth = theMonth - 1
            } else {
                adjustedMonth = 12
            }
        } else {
            adjustedMonth = theMonth
        }
        if (adjustedMonth === 0) {
            setMonth('January')
            setCurrentMonth('January')
            setYear(theYear)
            setCurrentYear(theYear)
        } else if (adjustedMonth === 1) {
            setMonth('February')
            setCurrentMonth('February')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 2) {
            setMonth('March')
            setCurrentMonth('March')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 3) {
            setMonth('April')
            setCurrentMonth('April')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 4) {
            setMonth('May')
            setCurrentMonth('May')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 5) {
            setMonth('June')
            setCurrentMonth('June')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 6) {
            setMonth('July')
            setCurrentMonth('July')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 7) {
            setMonth('August')
            setCurrentMonth('August')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 8) {
            setMonth('September')
            setCurrentMonth('September')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 9) {
            setMonth('October')
            setCurrentMonth('October')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 10) {
            setMonth('November')
            setCurrentMonth('November')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 11) {
            setMonth('December')
            setCurrentMonth('December')
            setYear(theYear)
            setCurrentYear(theYear)
        }else if (adjustedMonth === 12) {
            setMonth('December')
            setCurrentMonth('December')
            let adjustedYear = theYear - 1
            setYear(adjustedYear)
            setCurrentYear(adjustedYear)
        }
    }

    const prepAllTimesheetData = (sheets, setFunc) => {
        let masterData = []
        for(let i = 0; i < sheets.length; i++) {
            let modelObject = {
                timesheetId: sheets[i].timesheetId,
                teacherName: sheets[i].teacherName,
                school: sheets[i].school,
                monthNumber: sheets[i].monthNumber,
                totalCancellations: 0,
                cancellationDates: '',
                note: sheets[i].note
            }
            for(let j = 0; j < sheets[i].families.length; j++) {
                for(let k = 0; k < sheets[i].families[j].cancellations.length; k++) {
                    if(sheets[i].families[j].cancellations[k].cancellor === 'teacher' || sheets[i].families[j].cancellations[k].cancellor === 'sus-cancellation') {
                        modelObject.totalCancellations = modelObject.totalCancellations + 1
                        modelObject.cancellationDates = modelObject.cancellationDates + ' ' + `${sheets[i].monthNumber}/${sheets[i].families[j].cancellations[k].date}`
                    }
                }
            }
            masterData.push(modelObject)
        }
        masterData.sort((a,b) => (a.teacherName > b.teacherName) ? 1 : ((b.teacherName > a.teacherName) ? -1 : 0))
        setFunc([...masterData])
    }

    const getTimesheet = (timesheetId) => {
        axios.get(`${baseUrl}/oldtimesheet/${timesheetId}`, myHeader)
        .then((res) => {setOpenTimesheet(res.data)})
        .catch((err) => console.log(err))
    }

    const callForListOfFamilies = async (school) => {
        let res = await axios.get(`${baseUrl}/schoolsfamilies/${school}`, myHeader)
        let sortedList = res.data.sort((a, b) => {
            return(a.familyName < b.familyName) ? -1 : (a.familyName > b.familyName) ? 1 : 0
        })
        setListOfFamilies(sortedList)
    }

    const addWaveIdToFamilyInformation = (timesheetId, familyId, waveId) => {
        let notStateTimesheets = timesheets
        let familyToGetInfoAbout;
        for(let i = 0; i < listOfFamilies.length; i++) {
            if(listOfFamilies[i].familyId === familyId) {
                familyToGetInfoAbout = listOfFamilies[i]
            }
        }
        for(let i = 0; i < notStateTimesheets.length; i++) {
            if(notStateTimesheets[i].timesheetId === timesheetId) {
                let families = notStateTimesheets[i].families
                for(let i = 0; i < families.length; i++) {
                    if(families[i].id === familyId) {
                        families[i].familyWaveId = waveId
                        families[i].generalFamilyInfo = familyToGetInfoAbout
                    }
                }
            }
        }
        setTimesheets([...notStateTimesheets])
    }

    const updateFamiliesInDatabaseWithWaveId = (familyToUpdateEmail, newWaveId, sheetId) => {
        let myUpdatedTimesheet = openTimesheet
        for(let i = 0; i < myUpdatedTimesheet.families.length; i++) {
            if(myUpdatedTimesheet.families[i].email === familyToUpdateEmail) {
                myUpdatedTimesheet.families[i].familyWaveId = newWaveId
            }
        }
        //ADD THE WAVE ID TO THE CORRECT FAMILY IN TEACHERS TIMESHEET
        axios.post(`${baseUrl}/updatetimesheet`, {
            timesheetId: sheetId,
            families: myUpdatedTimesheet.families
        }, myHeader)
        .then((res) => {
            setOpenTimesheet({...res.data})
            document.body.style.cursor = 'default'
            document.getElementById('family-card__generate-wave-id-btn').style.cursor = "default"
        })
        .catch((err) => {
            console.log(err)
            console.log('error on step 4')
        })
    }

    const updateTimesheets = (updatedTimesheet) => {
        let oldTimesheets = timesheets
        let lastMonthsOld = lastMonthsTimesheets
        for(let i = 0; i < oldTimesheets.length; i++) {
            if(oldTimesheets[i].timesheetId === updatedTimesheet.timesheetId) {
                oldTimesheets[i].status = updatedTimesheet.status
                oldTimesheets[i].families = updatedTimesheet.families
                setTimesheets([...oldTimesheets])
                prepAllTimesheetData(oldTimesheets, setNewMaster)
                break
            }
        }
        for(let i = 0; lastMonthsOld.length; i++) {
            if(lastMonthsOld[i].timesheetId === updatedTimesheet.timesheetId) {
                lastMonthsOld[i].status = updatedTimesheet.status
                lastMonthsOld[i].families = updatedTimesheet.families
                setLastMonthsTimesheets([...lastMonthsOld])
                prepAllTimesheetData(lastMonthsOld, setLastMonthsMaster)
                break
            }
        }
    }

    const removeDeletedTimesheet = (id) => {
        setTimesheets(timesheets.filter(timesheet => timesheet.timesheetId !== id))
    }

    return(
        <div className='cancellation-spreadsheet__wrapper'>
            {noteHoverMessage.note &&
                <div className='note-hover-message__wrapper'>
                    <div className='note-hover-message__bubble'>
                    <p className='note-hover-message__message__teacher-name'>{noteHoverMessage.name}'s Note:</p>
                        <p className='note-hover-message__message'>{noteHoverMessage.note}</p>
                    </div>
                </div>
            }
            {openTimesheet && <CancellationEditTimesheet 
                callForListOfFamilies={callForListOfFamilies}
                addWaveIdToFamilyInformation={addWaveIdToFamilyInformation}
                updateFamiliesInDatabaseWithWaveId={updateFamiliesInDatabaseWithWaveId}
                listOfFamilies={listOfFamilies}
                timesheet={openTimesheet}
                families={openTimesheet.families}
                setOpenUpTheTimesheet={setOpenTimesheet}
                generateInvoicesFromTimesheet={false} 
                updateTimesheets={updateTimesheets}
                removeDeletedTimesheet={removeDeletedTimesheet}
                setOpenTimesheet={setOpenTimesheet}
            />}
            <h1>Teacher Cancellations</h1>
            <select className="month-selector" value={month} onChange={(e) => setMonth(e.target.value)}>
                {listOfMonths.map((m) => <option value={m} key={m}>{m}</option>)}
            </select>
            <select className="year-selector" value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
            </select>
            <div className='cancellations__school-tab__wrapper'>
                <div className='cancellations__school-tab' id={`mma-cancellations__school-tab`} onClick={() => setSchoolTab('mma')}>Mountainside</div>
                <div className='cancellations__school-tab' id={`lsma-cancellations__school-tab`} onClick={() => setSchoolTab('lsma')}>Lakeside</div>
                <div className='cancellations__school-tab' id={`tma-cancellations__school-tab`} onClick={() => setSchoolTab('tma')}>Treeside</div>
                <div className='cancellations__school-tab' id={`mor-cancellations__school-tab`} onClick={() => setSchoolTab('mor')}>Morningside</div>
                <div className='cancellations__school-tab' id={`psma-cancellations__school-tab`} onClick={() => setSchoolTab('psma')}>Parkside</div>
                <div className='cancellations__school-tab' id={`tem-cancellations__school-tab`} onClick={() => setSchoolTab('tem')}>Tempe</div>
                <div className='cancellations__school-tab' id={`den-cancellations__school-tab`} onClick={() => setSchoolTab('den')}>Denton</div>
                <div className='cancellations__school-tab' id={`tul-cancellations__school-tab`} onClick={() => setSchoolTab('tul')}>Tulsa</div>
            </div>
            <div className='cancellations-spreadsheet__whole-month'>
                <h3>{schoolTab.toUpperCase()}</h3>
                <div className="cancellations-spreadsheet__school-column">
                    <h1>{altMonth}</h1>
                    <table className='cancellation-table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Total</th>
                                <th>Dates</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lastMonthsMaster.map((sheet, index) => 
                                (sheet.school === schoolTab &&
                                    <tr key={index} className="cancellations-spreadsheet__each-teacher-block">
                                        <td onClick={() => getTimesheet(sheet.timesheetId)}>{sheet.teacherName}</td>
                                        <td onClick={() => getTimesheet(sheet.timesheetId)} style={sheet.totalCancellations > 0 ? {color: 'red', fontWeight: 900} : {color: 'black', fontWeight: 500}}>{sheet.totalCancellations}</td>
                                        <td onClick={() => getTimesheet(sheet.timesheetId)} className='cancellations-spreadsheet__cancellations-date'>{sheet.cancellationDates}</td>
                                        <td className='cancellations-spreadsheet__notes' onMouseEnter={() => setNoteHoverMessage({name: sheet.teacherName, note: sheet.note})} onMouseLeave={() => setNoteHoverMessage(false)} style={sheet.note !== '' ? {backgroundColor: 'rgba(0, 128, 0, 0.506)'} : {backgroundColor: '#fff'}}>{sheet.note !== '' && 'yes'}</td>
                                    </tr>
                                )
                            
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='cancellations-spreadsheet__whole-month'>
                <h3>{schoolTab.toUpperCase()}</h3>
                <div className="cancellations-spreadsheet__school-column">
                    <h1>{month}</h1>
                    <table className='cancellation-table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Total</th>
                                <th>Dates</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {newMaster.map((sheet, index) => 
                                (sheet.school === schoolTab &&
                                    <tr key={index} className="cancellations-spreadsheet__each-teacher-block">
                                        <td onClick={() => getTimesheet(sheet.timesheetId)}>{sheet.teacherName}</td>
                                        <td onClick={() => getTimesheet(sheet.timesheetId)} style={sheet.totalCancellations > 0 ? {color: 'red', fontWeight: 900} : {color: 'black', fontWeight: 100}}>{sheet.totalCancellations}</td>
                                        <td onClick={() => getTimesheet(sheet.timesheetId)} className='cancellations-spreadsheet__cancellations-date'>{sheet.cancellationDates}</td>
                                        <td className='cancellations-spreadsheet__notes' onMouseEnter={() => setNoteHoverMessage({name: sheet.teacherName, note: sheet.note})} onMouseLeave={() => setNoteHoverMessage(false)} style={sheet.note !== '' ? {backgroundColor: 'rgba(0, 128, 0, 0.506)'} : {backgroundColor: '#fff'}}>{sheet.note !== '' && 'yes'}</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
export default CancellationSpreadsheet